<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>
        <!-- 我的分数 -->
        <div class="main_r">
          <div class="mainr_top">
            <div><img src="@/assets/gerenzhongxin/geren16.png">
              我的学生
            </div>
            <div class="serachkuang">
              <input placeholder="请输入查询的学生姓名" v-model="userName" @keydown.enter="search" />
            </div>
            <div class="serachkuang">
              <input placeholder="请输入查询的学生电话" v-model="userPhone" @keydown.enter="search" />
            </div>
            <div class="serachkuang">
              <div class="sousuo" @click="search">
                查&nbsp;&nbsp;询
              </div>
              <div style="margin-left: 20px;" class="sousuo del" @click="delsearch">
                清&nbsp;&nbsp;空
              </div>
            </div>
            <div class="xs_li_r" style="background: #33c133;" @click="addUser(1)">
              <span>添加学生</span>
            </div>
          </div>

          <div class="xs_ul">
            <div class="xs_li" v-for="(item,index) in userList" style="display: flex;flex-direction: row;">
              <div class="xs_li_l" style="width: 50px;">
                <!-- pc端 -->
                <span
                  style="margin-right: 10px;border: 1px solid #F53824;border-radius: 20px;width: 32px;text-align: center;">{{index+1}}</span>
              </div>
              <div style="display: flex;flex-direction: column;padding: 10px 0px;padding-top: 10px;">
                <div style="display: flex;flex-direction: row">
                  <div class="xs_li_c" style="width: 240px;">
                    <div style="width: 100%;">
                      <figure class="wenjiansjh">
                        <!-- <img src="../../assets/gerenzhongxin/wdxs1.png" > -->
                        <figcaption style="font-size: 18px;font-weight: 600;text-align: left;">{{item.userName}}
                        </figcaption>
                      </figure>
                    </div>
                    <div style="width: 100%;margin-top: 5px;font-size: 14px;">
                      <span class="wenjiansjh">{{AREA_OBJ[item.userProvinces]}}</span>
                      <span>{{item.userSex==0?'女':'男'}}</span>
                      <span style="color: #F53824;margin-left: 15px;"><b>{{item.userPhone}}</b></span>
                    </div>
                  </div>
                  <div class="xs_li_c" style="width: 240px">
                    <span> <b style="color: #F53824;">{{SUBJECTTYPEOBJ[item.userSubject] }}</b></span>
                    <span v-if="item.userSelect!=null&&item.userSelect!=''" style="margin-top: 10px;font-size:14px;">
                      {{$utils.getUserXuanKe(item.userSelect) }}</span>
                  </div>
                  <div class="xs_li_c" style="width: 160px;padding-left: 10px;">
                    <span style="width: 100%;text-align: left;">分数:<b
                        style="padding-left: 10px;color: #e63233;">{{item.score}}</b></span>
                    <span style="width: 100%;text-align: left;margin-left: 0;margin-top: 10px;">位次:<b
                        style="padding-left: 10px;color: #e63233;">{{item.scoreRank}}</b></span>
                  </div>
                </div>
                <div style="width: 650px;padding-top: 5px;">
                  <div>学生资料&nbsp;:&nbsp;&nbsp;&nbsp;<b style="color: #F53824;">{{item.userImage}}</b></div>
                </div>
                <div style="width: 650px;padding-top: 5px;">
                  <div>填报要求&nbsp;:&nbsp;&nbsp;&nbsp;<b style="color: #F53824;">{{item.userQq}}</b></div>
                </div>
              </div>
              <!-- <div class="xs_li_c" style="width: 180px;">
                <span>{{item.userPhone}}</span>
              </div> -->
              <div style="display: flex; width: 200px;flex-wrap:wrap ">
                <div class="xs_li_r" v-if="item.spare == 1">
                  <span>当前学生</span>
                </div>
                <div class="xs_li_r xs_li_r_e" @click="selectScore(item,false)" v-if="item.spare == 0">
                  <span>选择学生</span>
                </div>
                <div class="xs_li_r xs_li_r_e" style="margin-left: 25px;" @click="selectScore(item,true)">
                  <span>志愿填报</span>
                </div>

                <div class="xs_li_r xs_li_r_e" style="margin-top: 20px;width: 70px;" @click="queryZy(item)">
                  <span v-if="item.spare4 != null">志愿({{item.spare4}})</span>
                  <span v-else style="color: black;">暂无志愿</span>
                </div>

                <div class="xs_li_r" style="margin-top: 20px;margin-left: 25px;" @click="addUser(0,item)">
                  <span>信息修改</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
    <div class="tuichuden" v-if="show">
      <div class="annou">
        <h1>{{opentype==1?'添加':'修改'}}学生</h1>
        <div style="display: flex;flex-direction: column;">
          <ul class="form uppwd">
            <li>
              <label>姓&nbsp;&nbsp;&nbsp;名：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.userName" placeholder="姓名">
              </div>
            </li>
            <li>
              <label>性&nbsp;&nbsp;&nbsp;别：</label>
              <div class="shoujiinp ">
                <el-radio v-model="user.userSex" :label="1">男</el-radio>
                <el-radio v-model="user.userSex" :label="0">女</el-radio>
              </div>
            </li>
          </ul>
          <ul class="form uppwd">
            <li>
              <label>省&nbsp;&nbsp;&nbsp;份：</label>
              <div class="shoujiinp" style="width: 230px;">
                <el-select v-model="user.userProvinces" class="inpda" @change="changeArea()" placeholder="省份"
                  v-if="opentype == 1">
                  <el-option v-for="item in areaList" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
                <b style="font-size: 16px;" v-else>{{AREA_OBJ[user.userProvinces]}}</b>
              </div>
            </li>
            <li>
              <label>手机号：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.phone" maxlength="11" placeholder="手机号">
              </div>
            </li>
          </ul>
          <ul class="form uppwd">
            <li>
              <label>学&nbsp;&nbsp;&nbsp;校：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.userSchool" placeholder="学校">
              </div>
            </li>
            <li>
              <label>班&nbsp;&nbsp;&nbsp;级：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.banji" placeholder="班级">
              </div>
            </li>
          </ul>
          <!-- <ul class="form uppwd" v-if="opentype == 0">
            <li>
              <label>用户名：</label>
              <div class="shoujiinp " style="width: 230px;">
                <b>{{user.loginName}}</b>
              </div>
            </li>
            <li>
              <label>密&nbsp;&nbsp;&nbsp;码：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.loginPwd" placeholder="密码">
              </div>
            </li>
          </ul> -->
          <ul class="form uppwd" v-if="opentype == 1">
            <li v-if="xuankeType == 0">
              <label>科&nbsp;&nbsp;&nbsp;目：</label>
              <div class="shoujiinp ">
                <!-- <input class="text mima_dd" v-model="user.subject" placeholder="科目"> -->
                <el-radio-group v-model="user.subject" @change="changesub">
                  <el-radio :label="1">理科</el-radio>
                  <el-radio :label="0">文科</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li v-if="xuankeType == 1&&opentype== 1">
              <label>选&nbsp;&nbsp;&nbsp;科：</label>
              <div class="shoujiinp " style="display: flex;flex-direction: row;">
                <el-radio-group v-model="xuanke1" style="margin-right: 20px;" @change="changesub">
                  <el-radio label="wl" style="width: 53px;">物理</el-radio>
                  <el-radio label="ls" style="width: 53px;">历史</el-radio>
                </el-radio-group>

                <el-checkbox-group v-model="xuanke" :max="2">
                  <el-checkbox label="hx">化学</el-checkbox>
                  <el-checkbox label="sw">生物</el-checkbox>
                  <!-- <br v-if="xuankeType !=1"> -->
                  <el-checkbox label="dl">地理</el-checkbox>
                  <el-checkbox label="zz">政治</el-checkbox>
                  <el-checkbox label="xxjs" v-if="xuankeArea.xingaokao6.indexOf(area)!=-1">信息技术</el-checkbox>
                </el-checkbox-group>
              </div>
            </li>
            <li v-if="xuankeType == 2&&opentype== 1">
              <label>选&nbsp;&nbsp;&nbsp;科：</label>
              <el-checkbox-group v-model="xuanke" :max="3" style="width: 400px;">
                <el-checkbox label="wl">物理</el-checkbox>
                <el-checkbox label="hx">化学</el-checkbox>
                <el-checkbox label="sw">生物</el-checkbox>
                <el-checkbox label="ls">历史</el-checkbox>
                <el-checkbox label="dl">地理</el-checkbox>
                <el-checkbox label="zz">政治</el-checkbox>
                <!-- <el-checkbox label="xxjs" v-if="xuankeArea.xingaokao6.indexOf(area)!=-1">信息技术</el-checkbox> -->
              </el-checkbox-group>
            </li>
          </ul>

          <ul class="form uppwd" v-show="yishushow&&opentype== 1">
            <li>
              <label>艺&nbsp;&nbsp;&nbsp;术：</label>
              <div class="shoujiinp ">
                <el-radio-group v-model="user.yishu" @change="changesub">
                  <el-radio :label="-1">否&nbsp;&nbsp;&nbsp;</el-radio>
                  <el-radio :label="0">美术</el-radio>
                  <el-radio v-show="false" :label="1">编导</el-radio>
                  <el-radio v-show="false" :label="2">书法</el-radio>
                  <el-radio v-show="false" :label="3">体育</el-radio>
                </el-radio-group>
              </div>
            </li>
          </ul>

          <ul class="form uppwd" v-if="opentype== 1">
            <li>
              <label>成&nbsp;&nbsp;&nbsp;绩：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.score" placeholder="成绩" @input="changescore">
              </div>
            </li>
            <li>
              <label>位&nbsp;&nbsp;&nbsp;次：</label>
              <div class="shoujiinp ">
                <input class="text mima_dd" v-model="user.scoreRank" placeholder="位次">
              </div>
            </li>
          </ul>
          <ul class="form uppwd">
            <li>
              <label>学生资料：</label>
              <div class="shoujiinp ">
                <!-- <input class="text mima_dd" v-model="user.info" type="textarea" style="width: 540px;" placeholder="填报要求"> -->
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="学生资料" style="width: 540px;"
                  v-model="user.userImage">
                </el-input>
              </div>
            </li>
          </ul>
          <ul class="form uppwd">
            <li>
              <label>填报要求：</label>
              <div class="shoujiinp ">
                <!-- <input class="text mima_dd" v-model="user.info" type="textarea" style="width: 540px;" placeholder="填报要求"> -->
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="填报要求" style="width: 540px;"
                  v-model="user.info">
                </el-input>
              </div>
            </li>
          </ul>
        </div>
        <dl class="two">
          <dt @click="quxiao">取消</dt>
          <dd @click="quit">确认</dd>
        </dl>
      </div>
    </div>


  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import city from '../../assets/city.js'
  import vSerch from '../../components/vSerch.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      vSerch
    },
    data() {
      return {
        zydname: "",
        selectId: "",
        userList: [],
        show: false,
        xuanke1: 'wl',
        xuanke: [],
        areaList: [],
        xuankeArea: [],
        AREA_OBJ: this.$utils.getlocalStorage('AREA_OBJ'),
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage('SUBJECTTYPEOBJ'),
        yishushow: false,
        area: null,
        // tianbaoType: 0,
        xuankeType: 0, //0 3+3 1:3+1+2

        opentype: 0, //0 修改  1  添加
        userName: '',
        userPhone: '',
        pageSize:10,
        pageNum:1,
        user: {

          userName: "",
          userSex: 1,
          userProvinces: "",
          userSchool: "",
          banji: "",
          subject: 1,
          xuanke1: "",
          phone: "",
          xuanke: "",
          yishu: -1,
          score: "",
          scoreRank: "",
          info: "",
          userImage: "",
          spare:0
        }
      }
    },


    methods: {
      addUser(type, item) {
        let _this = this;
        this.opentype = type
        if (type == 1) {
          this.user = {
            userName: "",
            userSex: 1,
            userProvinces: "",
            userSchool: "",
            banji: "",
            phone: "",
            subject: 1,
            xuanke1: "",
            xuanke: "",
            yishu: -1,
            score: "",
            scoreRank: "",
            info: "",
            userImage: "",
            spare:0
          }
          this.$req.getMemberNum({
            num: _this.userList.length,
            uId: _this.$utils.getlocalStorage('memberInfo').uid
          }).then(function(response) {
            if (response.status == '0') {
              _this.show = true;
            } else {
              _this.$message.error({
                message: response.message
              });
            }
            // _this.getdata();
          });

        } else {
          this.user = {
            userId: item.userId,
            userName: item.userName,
            userSex: item.userSex,
            userProvinces: item.userProvinces,
            userSchool: item.userSchool,
            banji: item.userEmail,
            phone: item.userPhone,
            subject: item.userSubject,
            userSelect: item.userSelect,
            score: item.score,
            scoreRank: item.scoreRank,
            info: item.userQq,
            loginName: item.loginName,
            loginPwd: item.loginPwd,
            userImage: item.userImage,
            spare: item.spare
          }
          this.show = true;
        }


      },
      changeArea() {

        this.area = this.$utils.getlocalStorage('AREA_OBJ')[this.user.userProvinces]
        //this.$message.error({message:this.area,offset:150});
        if (this.xuankeArea.xingaokao.indexOf(this.area) == -1) {
          this.xuankeType = 0;
          this.user.subject = 1;
        } else if (this.xuankeArea.xingaokao2.indexOf(this.area) != -1 || this.xuankeArea.xingaokao4.indexOf(this
            .area) != -1) {
          this.xuankeType = 1;
          this.xuanke = [];
          this.xuanke1 = 'wl'
        } else {
          //3+3
          this.xuankeType = 2
          this.xuanke = [];
          // this.xuanke1 = 'wl';
        }
        if (this.xuankeArea.yishuarea.indexOf(this.area) != -1) {
          this.yishushow = true;
        } else {
          this.yishushow = false;
        }
      },

      queryZy(item) {
        // this.$utils.setlocalStorage('ZYD_UserId',item.userId)
        this.$router.push({
          name: 'grzx_wodezhiyuan',
          params: {
            id: item.userId
          }
        })
      },
      quxiao() {
        this.show = false;
      },

      quit() {
        let _this = this;
        if (this.opentype == 1) {
          if (this.user.userName == '') {
            this.$message.error({
              message: "请输入学生姓名"
            });
            return;
          }
          if (this.user.userProvinces == '') {
            this.$message.error({
              message: "请选择省份"
            });
            return;
          }
          if (!this.$utils.regphone(this.user.phone)) {
            this.$message.error({
              message: "请输入正确的手机号"
            });
            return;
          }
          if (!this.getsubject()) {
            return true;
          }


          if (this.user.score == null || this.user.score == "") {
            this.$message.error({
              message: "请输入学生成绩"
            });
            return;
          }
          if (this.user.score < 150 || this.user.score > 750) {
            this.$message.error({
              message: "请输入正确的学生成绩"
            });
            return;
          }
          if (this.xuankeType != 0) {
            this.user.userSelect = ""
            if (this.xuankeType == 1) {
              this.user.userSelect = this.xuanke1 + ",";
            }

            this.user.userSelect += this.xuanke.join(",")
          }
          console.log(this.user);
          let obj = {
            userName: this.user.userName,
            userSex: this.user.userSex,
            userPhone: this.user.phone,
            userEmail: this.user.banji,
            userSelect: this.user.userSelect,
            userSubject: this.user.subject,
            userProvinces: this.user.userProvinces,
            userSchool: this.user.userSchool,
            score: this.user.score,
            scoreRank: this.user.scoreRank,
            userQq: this.user.info,
            userImage: this.user.userImage
          }
          this.$req.insert('userTable', obj).then(function(response) {
            _this.show = false;
            _this.getdata();
          });
        } else {
          let obj = {
            userName: this.user.userName,
            userSex: this.user.userSex,
            userPhone: this.user.phone,
            userEmail: this.user.banji,
            userSchool: this.user.userSchool,
            userQq: this.user.info,
            loginName: this.user.loginName,
            loginPwd: this.user.loginPwd,
            userQq: this.user.info,
            userId: this.user.userId,
            userImage: this.user.userImage
          }
          this.$req.update('userTable', obj).then(function(response) {
            _this.show = false;
            if(_this.user.spare == 1){
              let u = _this.$utils.getlocalStorage('userInfo')
              u.userPhone = _this.user.phone
              _this.$utils.setlocalStorage('userInfo',u);
            }

            _this.getdata();
          });
        }


      },
      changesub() {
        this.user.score = "";
        this.user.scoreRank = "";
      },
      getsubject() {
        if (this.xuankeType == 0) {
          //老高考
          if (this.user.yishu != -1) {
            this.user.subject = (this.user.subject == 0 ? 1 : 0) + 5 + this.user.yishu * 2
          }
        } else if (this.xuankeType == 1) {
          //3+1+2
          if (this.xuanke.length != 2) {
            this.$message.error({
              message: "请正确的选择科目"
            });
            return false;
          }
          //新高考 3+1+2
          if (this.xuanke1.indexOf('wl') != -1) {
            this.user.subject = 3
          } else {
            this.user.subject = 4
          }
          if (this.user.yishu != -1) {
            this.user.subject = (this.user.subject == 4 ? 4 : 0) + 17 + this.user.yishu
          }
        } else if (this.xuankeType == 2) {
          //新高考 3+3
          if (this.xuanke.length != 3) {
            this.$message.error({
              message: "请正确的选择科目"
            });
            return false;
          }
          this.user.subject = 2;
          if (this.user.yishu != -1) {
            this.user.subject = 13 + this.user.yishu
          }
        }
        return true;
      },
      changescore() {
        let _this = this;
        this.user.scoreRank = '';
        if (this.user.userProvinces == null || this.user.userProvinces == "") {
          this.$message.error({
            message: "请选择学生省份"
          });
          return;
        }
        if (_this.user.score == null || _this.user.score == "") {
          this.$message.error({
            message: "请输入学生成绩"
          });
          return;
        }
        if (_this.user.score < 150) {
          return;
        }
        if (_this.user.score > 750) {
          this.$message.error({
            message: "请输入正确的学生成绩"
          });
          return;
        }
        if (!this.getsubject()) {
          return true;
        }

        _this.$req.getRankByscore({
          subject: _this.user.subject,
          areaid: _this.user.userProvinces,
          score: _this.user.score
        }).then(function(resp) {
          console.log(resp)
          if (resp.status == 0 && resp.data != 0) {
            _this.user.scoreRank = resp.data;
          }
        })
      },
      search() {
        this.getdata();
      },
      delsearch() {
        this.userName = '';
        this.userPhone = '';
        this.pageNum = 1
        this.getdata();
      },
      getdata() {
        let _this = this;
        this.$req.queryByGbLimit( {
          pageSize: 0,
          pageNum: 1,
          queryObj: {userName:this.userName,userPhone :this.userPhone}
        }).then(function(resp) {
          _this.userList = resp.data;
          if (_this.userList.length == 1) {
            if (_this.userList[0].spare == 0) {
              _this.selectScore(_this.userList[0], false)
              // _this.getdata()
            }
          }
        })
      },
      selectScore(item, to) {
        let _this = this;
        this.$req.userGaoInfoUpdate({
          uId: item.spare3,
          gId: item.spare2,
          userId: item.userId
        }).then(function(resp1) {
          _this.$message.success({
            message: "学生选择成功"
          },3);
          _this.getdata();
          _this.$req.getUserInfo({}).then(function(resp) {
            //删除历史数据
            let userId = item.userId;
            _this.$utils.removelocalStorage("memberInfo")
            _this.$utils.removelocalStorage("userInfo")
            _this.$utils.removelocalStorage("scoreInfo")
            _this.$utils.removelocalStorage("userCang")
            _this.$utils.removelocalStorage("userGuan")
            _this.$utils.removelocalStorage("areaInfo")
            _this.$utils.removelocalStorage("TianbaoQueryKey")
            _this.$utils.removelocalStorage('userDate')
            _this.$utils.removelocalStorage('ZhiYuanDanObj')
             _this.$utils.removelocalStorage('disTime')

            if(resp.data.userScore!=null){
              _this.$utils.setlocalStorage('disTime', resp.data.userScore.disTime)
            }

            _this.$utils.setlocalStorage('userInfo', resp.data.userTable)
            _this.$utils.setlocalStorage('userName',resp.data.userTable.loginName)
            _this.$utils.setlocalStorage('memberInfo', resp.data.memberTable)
            localStorage.setItem("userId",resp.data.userTable.userId)
            let cang = {
              major: resp.data.major,
              college: resp.data.college,
              collegescore: resp.data.collegescore,
              majorscore: resp.data.majorscore
            }
            if (resp.data.major == null) {
              cang.major = []
            }
            if (resp.data.college == null) {
              cang.college = []
            }
            if (resp.data.collegescore == null) {
              cang.collegescore = []
            }
            if (resp.data.majorscore == null) {
              cang.majorscore = []
            }
            _this.$utils.setlocalStorage('userCang', cang)
            if (resp.data.userTable.userProvinces != null && resp.data.userTable.userProvinces != ""
            ) {
              let xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
              let areaId = parseInt(resp.data.userTable.userProvinces)
              if (resp.data.userScore) {
                areaId = parseInt(resp.data.userScore.scoreArea)
              }
              let area = _this.$utils.getlocalStorage('AREA_OBJ')[areaId]
              if (xuankeArea.xingaokao.indexOf(area) == -1) {
                _this.$utils.setlocalStorage('tianbaoType', 0) //老高考
              } else if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao3.indexOf(area) !=
                -1) {
                _this.$utils.setlocalStorage('tianbaoType', 2) //专业组
              } else {
                _this.$utils.setlocalStorage('tianbaoType', 1) //单专业
              }
              _this.$utils.setlocalStorage('areaInfo', {
                areaId: areaId,
                areaName: area,
                areaFullName: _this.$utils.getAreaFullName(areaId)
              })
            }
            if (resp.data.userScore) {
              resp.data.userScore.score += ""
              _this.$utils.setlocalStorage('scoreInfo', resp.data.userScore)
            }
            if (to) {
              _this.$router.push("xuanzheyuanhuoye")
            }
          })
        })
      },
      deleteStu(uid) {
        let _this = this;
        _this.$req.batchDelete("userGaoInfo", {
          id: uid
        }).then(function(resp) {
          _this.$message.success({
            message: "学生删除成功"
          });
          _this.getdata();
        })

      }
    },
    created() {
      this.xuankeArea = this.$utils.getlocalStorage('xuankeArea')
      this.areaList = city.area
      this.getdata();

    }
  }
</script>

<style scoped>
  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    margin-top: 90px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .jibenxinxi {
    width: 290px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1050px;
    min-height: 878px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }


  .duanxin {
    border: none;
    position: absolute;
    left: 340px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 0px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 0px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 230px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  input::placeholder {
    color: #a4a4a4;
  }

  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 690px;
    height: 580px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .uppwd {
    display: flex;
    flex-direction: row;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 230px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 我的学生 */
  .xs_ul {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* .xs_ul_you{width: 100%;height: auto; } */
  .xs_li {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 20px;
    width: 100%;
    /* height: 64px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background: url(../../assets/gerenzhongxin/wdxs2.png)no-repeat;
    background-size: 100% 100%;
  }

  .xs_li_r {
    padding: 0 10px;
    height: 28px;
    background: linear-gradient(180deg, #F53824 0%, #FE9603 100%);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .xs_li_r_e {
    background: unset;
    color: #F53824;
    border: 1px solid #F53824;
  }

  .xs_li_l {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .xs_li_l figure {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .xs_li_l figure img {
    height: 46px;
    margin-right: 10px;
  }

  .xs_li_l figure figcaption {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .xs_li_l span {
    margin-left: 0px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .xs_li_c {
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .xs_li_c span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .xs_li_c span:nth-of-type(2) {
    margin-left: 15px;
  }

  .mieyou {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .serachkuang input {
    border: none;
    width: 230px;
    height: 28px;
    background: #fff;
    font-size: 15px;
    opacity: 1;
    border-radius: 6px;
    padding-left: 15px;
    border: 1px solid #E0E0E0;
  }

  .sousuo{
    width: 80px;
    height: 25px;
    font-size: 15px;
    color: #fff;
    line-height: 25px;
    font-family: PingFang SC;
    font-weight: 800;
    padding: 0px 15px 0px 15px;
    background: linear-gradient(180deg, #F53824 0%, #FE9603 100%);
    border-radius: 6px;
  }

  .del{
    color: #F53824;
    background: #FFFFFF;
    border: 1px solid #F53824;
    border-radius: 8px;
  }




  @media (min-width:750px) {
    .shoujifig {
      display: none !important;
    }
  }

  @media (max-width:750px) {
    .wenjiansjh {
      display: none !important;
    }

    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .manpin {
      padding: 20px 0;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .main_r {
      height: auto;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .main_r {
      width: 100%;
      display: flex;
      flex-direction: column;
    }



    /* 我的学生 */
    .xs_li {
      padding: 0 10px;
    }

    .xs_li_l figure img {
      height: 36px;
    }

    .xs_li_l figure figcaption {
      font-size: 15px;
      display: flex;
      flex-direction: column;
    }

    .xs_li_l figure figcaption span:nth-of-type(1) {
      color: #29A7E1;
    }

    .xs_li_l figure figcaption span:nth-of-type(2) {
      font-size: 10px;
    }

    .xs_li_l span {
      font-size: 15px;
      margin-left: 0px;
    }

    .xs_li_c {
      flex-direction: column-reverse;
      align-items: end;
      justify-content: center;
    }

    .xs_li_c span {
      font-size: 12px;
    }

    .xs_li_r {
      flex-direction: column;
      width: 45px;
      height: auto;
    }

    .mieyou {
      margin-top: 40px;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }


  }
</style>



// WEBPACK FOOTER //
// src/views/mine/c_wdxuesheng.vue